<mat-progress-bar class="loading-bar" mode="indeterminate" [color]="'warn'" *ngIf="loading" ></mat-progress-bar>
<router-outlet></router-outlet>
